import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App';
import store from './store/index';
import comApp from './common/app';
import tools from './common/tools';

//加载错误操作设置
import ErrorData from './auth/error_handle.js';

//加载本地路由
import BaseRoute from './routes/base';
import DynamicRoute from './routes/dynamic';
import SystemRoute from './routes/system';
import ExampleRoute from './routes/example';

import Jquery from 'jquery';

//加载汉子package
import { Tools, Route, Log, Alert } from 'hanzi-mobile-package';

//弹出框类
import { MessageBox, Toast, Indicator } from 'mint-ui';

//ydui UI
// import 'vue-ydui/dist/ydui.rem.css';
import 'vue-ydui/dist/ydui.base.css';

// import Vconsole from 'vconsole'   //移动端调试工具之一：vconsole
// const vConsole = new Vconsole()

var messageBox = MessageBox;
var toast = Toast;
var indicator = Indicator;
Alert.ui.messageBox = messageBox;
Alert.ui.toast = toast;
Alert.ui.indicator = indicator;

import Promise from 'bluebird';

import './assets/sass/common/base.scss';

// var tools = Tools;
// var tools = './common/tools.js';
var log = Log;
var alert = Alert;

//定义错误操作数组
tools.errorData = ErrorData.data;


//初始化路由
Route.data.baseRoute = BaseRoute;
Route.data.dynamicRoute = DynamicRoute;
Route.data.systemRoute = SystemRoute;
Route.data.exampleRoute = ExampleRoute;

var app = window;

// Tools.vue = Vue;
app.Alert = alert;
// tools.alert = alert;
tools.vue = Vue;


app.tools = tools;
app.config = app.g;
app.log = log;
app.Promise = Promise;
app.app = comApp;
app.$ = Jquery;

// 兼容APP的一些样式
app.H = tools.alert;
app.H.$confirm = tools.alert.confirm;
app.H.$toast = tools.alert.toast;

app.H.$showProgress = tools.alert.loading;
app.H.$hideProgress = tools.alert.closeLoading;
app.H.$getPageParam = tools.url.query;

app.tools.cache = {
	/* 获取 */
	get: function (name) {
		return window.localStorage.getItem(name);
	},
	/* 保存 */
	set: function (name, value) {
		window.localStorage.setItem(name, value);
	},
	/* 删除 */
	del: function (name) {
		window.localStorage.removeItem(name);
	}
};

// app.tools.cache = {
// 	/* 获取 */
// 	get: function (name) {
// 		var arr = document.cookie.split('; ');
// 		var i = 0;
// 		for (i = 0; i < arr.length; i++) {
// 			var arr2 = arr[i].split('=');

// 			if (arr2[1] !== "" && arr2[0] === name) {
// 			return decodeURIComponent(arr2[1]);
// 			}
// 		}
// 	},
// 	/* 保存 */
// 	set: function (name, value, iDay) {
// 		var oDate = new Date();
// 		oDate.setDate(oDate.getDate() + iDay);
// 		if (name == 'Authorization') {
// 			document.cookie = name + '=' + encodeURIComponent(value) + ';path=/';
// 		} else {
// 			document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + oDate + ';path=/';
// 		}
// 	},
// 	/* 删除 */
// 	del: function (name) {
// 		this.set(name, "", -1);
// 	}
// };


Vue.use(VueRouter);

/* 定义路由 */
const routes = Route.routes();

const router = new VueRouter({
	mode: 'history',
	routes
});

// 当前网址
const hostname = document.location.hostname;
// 网址前缀：localhost(本地调试)、wap(总店环境和分销商环境)
const hostPrefix = hostname.split(".")[0];

//用于记录刷新页面状态
tools.cache.set('locationJump', 1);

//记录刚进页面时的链接，ios用到
tools.cache.set('initUrl', location.href);

import Login from './auth/index.js';
/* 初次打开,检查权限 */
router.beforeEach((to, from, next) => {	
	if (to.path == '/chat') {
		if (tools.url.params('token')) {
			tools.cache.set('Authorization', tools.url.params('token'));
			tools.cache.set('isLogin', 1);
			next();
			return;
		}
	}
	// tools.ajax({
	// 	url: "/api/islogins",
	// 	type: "GET",
	// 	successFun: function (res) {
	// 		// if (res.data.is_auth) {
	// 			if (res.data.is_user) {
	// 				tools.cache.set('is_login',1);
	// 			}else{
	// 				tools.cache.del('is_login');
	// 			}
	// }else{
	// 	tools.cache.del('is_login');
	// }
	if (tools.url.params('share_uidcode') && tools.url.params('share_uidcode') !== "=" && tools.url.params('share_uidcode') !== "") {
		window.sessionStorage.setItem('share_uidcode', tools.url.params('share_uidcode'));
	}

	if(to.path == "/authorization_error") {
		// "https://wap.test.megaovip.com/authorization_error?msg=该账号已被禁用，请联系管理人员解禁&callback=https://wap.test.megaovip.com/root_login?type=1"
		if(tools.url.params('callback')){
			tools.alert.error(decodeURIComponent(tools.url.params('msg')));
			sessionStorage.clear();
			localStorage.clear();
			setTimeout(() => {
				window.location.href = decodeURIComponent(tools.url.params('callback'));
			}, 1000)
		}
	}

	if (tools.url.params('shop') && tools.url.params('shop') !== "=" && tools.url.params('shop') !== "") {
		if(window.sessionStorage.getItem('shop')){
			next();
		}else{
			window.sessionStorage.setItem('shop', tools.url.params('shop'));
			tools.ajax({
				url: '/api/shop/infos',
				type: 'GET',
				successFun: function (res) {
					if (!res.data) {
						window.sessionStorage.removeItem('shop');
					}
					window.sessionStorage.setItem('is_meine',res.data.is_mine);
					window.sessionStorage.setItem('t',res.data.index_type); 

					/**
					 * 通过判断域名和店铺名跳转至不同环境（网址）或页面
					 * 1、本地环境不需要进行处理
					 * 2、如果进来是分销商环境则不需要处理
					 * 3、如果进来是总店网址，则跳转至分销商网址 "https://wap.technical.services.megaovip.com" + to.fullPath;
					 */
					if(hostPrefix == "wap" && hostname.indexOf('technical') == -1){
						let newUrl = "http://wap.technical.services" + hostname.match(/wap(\S*)megaovip/)[1] +  "megaovip.com" + to.fullPath;
						window.open(newUrl, "_self");
					}else{
						next();
					}
				},
				errorFun: function (error_data, status, headers, error_obj) {
					// tools.alert.error(error_data.error_msg);
					next();
				},
			})
		}	
	}
	else {
		/**
		 * 通过判断域名和店铺名跳转至不同环境（网址）或页面
		 * 1、本地环境不需要进行处理
		 * 2、如果进来是总店环境则不需要处理
		 * 4、如果进来是https://technical.services.megaovip.com 则跳转到一个欢迎页
		 */
		if(hostPrefix == "wap" && hostname.indexOf('technical') > -1 && to.path != "/technical_tips" && to.path != "/authorization_error"){
			next({
				path: '/technical_tips'
			});
		}else{
			next();
		}
	}

	
	// },
	// errorFun: function (error_data, status, headers, error_obj) {
	// 	tools.alert.error(error_data.error_msg);
	// }
	// });
	// Login(to, from, next);
})

/* 定义路由示例 */
app.tools.router = router;

// 解决微信浮窗再次点开时session读取不到的bug
router.constructor.prototype.replaceT = router.replace;
router.constructor.prototype.pushT = router.push;

app.tools.router.push = function (obj) {
	var obj = obj || { path: '', query: {} };
	var obj = obj || { path: '', query: {} };
	if (!obj.query) {
		obj.query = {};
	}

	if (obj.query.is_init) {
		return;
	}
	obj.query.is_init = true;
	if (window.sessionStorage.getItem('shop')) {
		obj.query.shop = window.sessionStorage.getItem('shop');
		if (window.sessionStorage.getItem('share_uidcode')) {
			obj.query.share_uidcode = window.sessionStorage.getItem('share_uidcode');
		}
	}
	obj.query.is_init = true;
	router.pushT({
		path: obj.path,
		query: obj.query,
	});
};
app.tools.router.replace = function (obj) {
	// console.log(router.__proto__.replace);
	// return;
	var obj = obj || { path: '', query: {} };
	if (!obj.query) {
		obj.query = {};
	}
	// console.log(JSON.stringify(obj))

	if (obj.query.is_init) {
		return;
	}
	obj.query.is_init = true;
	if (window.sessionStorage.getItem('shop')) {
		obj.query.shop = window.sessionStorage.getItem('shop');
		if (window.sessionStorage.getItem('share_uidcode')) {
			obj.query.share_uidcode = window.sessionStorage.getItem('share_uidcode');
		}
	}
	// console.log('路由跳转',router.replaceT)
	router.replaceT({
		path: obj.path,
		query: obj.query,
	});
};
/* 定义路由数组 */
app.tools.routes = routes;

//定义是否可以初始化签名
app.canauthinit = 1;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	template: '<App/>',
	components: { App },
	router,
	store
});

// 解决安卓在微信上字体放大后样式错乱
if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
	handleFontSize();
} else {
	if (document.addEventListener) {
		document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
	} else if (document.attachEvent) {
		document.attachEvent("WeixinJSBridgeReady", handleFontSize);
		document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
	}
}

function handleFontSize() {
	// 设置网页字体为默认大小
	WeixinJSBridge.invoke('setFontSizeCallback', {
		'fontSize': 0
	});
	// 重写设置网页字体大小的事件
	WeixinJSBridge.on('menu:setfont', function () {
		WeixinJSBridge.invoke('setFontSizeCallback', {
			'fontSize': 0
		});
	});
}


// WEBPACK FOOTER //
// ./src/main.js